import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { OffshoreGatepassFormData } from "@features/gatepass/schema/offshoreGatepassFormSchema";
import { t } from "i18next";
import { FormProvider, type UseFormReturn } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

export interface FormContext {
  formData: UseFormReturn<OffshoreGatepassFormData>;
  updateFormData: (key: string, value: unknown) => void;
}

const TRANSLATION_KEY = "gatepass";

const GatepassDetails = () => {
  const { formData, updateFormData } = useOutletContext<FormContext>();
  const requestForOptions = [
    { label: t("common.entry"), value: "entry" },
    { label: t("common.exit"), value: "exit" },
  ];
  const entryTypeOptions = [
    { label: t("common.single"), value: "single" },
    { label: t("common.multiple"), value: "multiple" },
  ];
  const gatepassDurationOptions = [
    { label: t("common.daily"), value: "daily" },
    { label: t("common.weekly"), value: "weekly" },
  ];

  return (
    <FormProvider {...formData}>
      <FormSection title={t(`${TRANSLATION_KEY}.gatepass-details`)}>
        <div className="col-span-full flex">
          <FormItem<OffshoreGatepassFormData, "gatepassDuration">
            required
            name="gatepassDuration"
            label={t(`${TRANSLATION_KEY}.gatepass-duration`)}
            type="radio"
            options={gatepassDurationOptions}
            testId="radio-offshore-gatepassDuration"
            onFieldChange={updateFormData}
            horizontalRadioButtons
            inlineRadioButtons
            radioValidationBelowButtons
          />
        </div>
        <div className="col-span-full flex">
          <FormItem<OffshoreGatepassFormData, "requestFor">
            name="requestFor"
            type="radio"
            options={requestForOptions}
            label={t(`${TRANSLATION_KEY}.request-for`)}
            testId="radio-offshore-requestFor"
            onFieldChange={updateFormData}
            horizontalRadioButtons
            inlineRadioButtons
            radioValidationBelowButtons
            disabled
          />
        </div>
        <div className="col-span-full flex">
          <FormItem<OffshoreGatepassFormData, "entryType">
            name="entryType"
            type="radio"
            options={entryTypeOptions}
            label={t(`${TRANSLATION_KEY}.entry-type`)}
            testId="radio-offshore-entryType"
            onFieldChange={updateFormData}
            horizontalRadioButtons
            inlineRadioButtons
            radioValidationBelowButtons
            disabled
          />
        </div>
      </FormSection>
    </FormProvider>
  );
};

export default GatepassDetails;
